import { FC } from 'react';

import {
  Block,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
} from 'modules/_shared/components/LayoutV9/block/Block';
import Head from 'modules/_shared/components/LayoutV9/head/Head';
import Page from 'modules/_shared/components/Pages/Page';
import Content from 'modules/_shared/components/LayoutV9/content/Content';
import { PreviewCard } from 'modules/_shared/components/LayoutV9/preview/Preview';
import GoBackButton from 'modules/_shared/components/Buttons/GoBackButton';

const Legal: FC = () => (
  <Page className="bg-lighter pb-5">
    <Head title="Información Legal" />
    <Content>
      <div className="content-page wide-md m-auto">
        <BlockHead size="lg" wide="xs" className="mx-auto">
          <BlockHeadContent className="text-center">
            {/* @ts-ignore */}
            <BlockTitle tag="h2" className="fw-normal">
              Información Legal
            </BlockTitle>
            {/* @ts-ignore */}
            <BlockDes>
              <p className="lead">Área Privada accionistas</p>
              <p className="text-soft ff-italic">Fecha de publicación: 2026</p>

              <GoBackButton hideWhenNoHistory />
            </BlockDes>
          </BlockHeadContent>
        </BlockHead>
        {/* @ts-ignore */}
        <Block>
          {/* @ts-ignore */}
          <PreviewCard className="card-inner">
            <div className="entry">
              <h3 className="mb-3">Titularidad</h3>
              <p>
                El titular de la presente página web https://accionistas.axa.es
                es AXA SEGUROS GENERALES, S.A. DE SEGUROS Y REASEGUROS con CIF
                A-60917978 y domicilio social en la C/ Monseñor Palmer 1 de
                Palma de Mallorca y que figura inscrita en el Registro Mercantil
                de Palma de Mallorca, al Tomo 2325, Folio 97, Hoja PM-61041.
              </p>
              <p>
                AXA SEGUROS GENERALES, S.A. DE SEGUROS Y REASEGUROS se encuentra
                bajo la supervisión de la DIRECCIÓN GENERAL DE SEGUROS Y FONDOS
                DE PENSIONES (DGSFP), y consta inscrita en el Registro obrante
                en la DGSFP con la clave administrativa C0723.
              </p>
              <p>
                Recuerde que, si no está de acuerdo con las condiciones
                establecidas en este documento, no debe continuar navegando ni
                accediendo a los contenidos de la misma y que, en cualquier
                caso, el hecho de acceder a la página web supone la aceptación
                de las presentes condiciones.
              </p>

              <h3 className="mb-3">Condiciones generales de uso</h3>

              <h4 className="mb-2">I.- Objeto</h4>
              <p>
                La utilización de la página web atribuye la condición de usuario
                a todo aquel que se logue en esta. En consecuencia, con
                anterioridad a la utilización del servicio, el usuario debe leer
                atentamente estas Condiciones Generales de uso (en adelante,
                &quot;Acuerdo&quot;), así como la Política de Privacidad, si
                fuera de aplicación.
              </p>
              <p>
                Dicha página web puede recabar los datos necesarios del usuario
                para que AXA pueda facilitar, servicios e información acerca de
                los productos y servicios que puede contratar con AXA en España.
                La información contenida en esta página web no está dirigida a
                inversores a quienes la normativa vigente no les permita
                adquirir, distribuir, comercializar o ser sujetos pasivos de una
                oferta de productos de este tipo. Por ello, es necesario conocer
                con carácter previo las condiciones legales de adquisición,
                distribución o comercialización de los productos.
              </p>

              <h4 className="mb-2">II.- Identificación del usuario</h4>
              <p>
                Será considerado como usuario de esta microsite cualquier
                persona que navegue por ella, incluyendo quienes soliciten ser
                contactados por AXA mediante la cumplimentación de los
                formularios que se les ofrezcan en cada caso. En determinadas
                circunstancias se recogerán datos personales del usuario, cuyo
                tratamiento está sometido a estrictos requisitos detallados
                tanto en la Política de Privacidad como en la Política de
                cookies, al objeto de que el usuario esté debidamente informado.
              </p>

              <h4 className="mb-2">III.- Utilización del servicio de acceso</h4>
              <p>
                El usuario se compromete a utilizar el servicio de acceso a
                Internet de buena fe, de forma diligente y adecuada, sin
                incurrir en actividades que puedan ser consideradas ilícitas o
                ilegales, que infrinjan los derechos del prestador de servicios
                o de terceros, cumpliendo en todo momento con las reglas de buen
                comportamiento en la red y con las políticas de uso aceptable de
                las redes frecuentadas, no haciendo uso fraudulento de la
                información ni de los contenidos existentes en ellas.
              </p>
              <p>
                Asimismo, el usuario se compromete expresamente a no llevar a
                cabo ninguna conducta tendente a deteriorar o sobrecargar el
                servicio y, especialmente a evitar:
              </p>
              <ol className="list mb-4">
                <li>
                  Destruir, alterar, inutilizar o de cualquier otra forma dañar
                  los datos, programas o documentos electrónicos del prestador
                  de servicios o de terceros. Obstaculizar el acceso de otros
                  usuarios a Internet, así como realizar acciones que dañen,
                  interrumpan o generen errores en el sistema de acceso.
                </li>
                <li>
                  El envío masivo de comunicaciones comerciales por correo
                  electrónico u otro medio de comunicación electrónica
                  equivalente a destinatarios que no hayan solicitado
                  expresamente su remisión.
                </li>
                <li>
                  Intentar acceder, eliminar, copiar o modificar los mensajes de
                  correo electrónico de otros usuarios.
                </li>
                <li>
                  Introducir programas, virus o cualquier otro dispositivo que
                  cause o sea susceptible de causar cualquier tipo de alteración
                  o perjuicio en los sistemas informáticos del prestador de
                  servicios o de terceros.
                </li>
              </ol>
              <p>
                El servicio prestado por AXA a través de esta página es de
                carácter gratuito y no existe compromiso por parte de AXA en el
                mantenimiento continuado del servicio, reservándose la facultad
                de suspenderlo o finalizarlo, parcial o totalmente, así como
                modificar los contenidos en cualquier momento.
              </p>
              <p>
                Recuerde que, si no está de acuerdo con las condiciones
                establecidas en este documento, no debe continuar navegando ni
                accediendo a los contenidos de la página web y que, en cualquier
                caso, el hecho de acceder a esta supone la aceptación de las
                citadas condiciones.
              </p>

              <h4 className="mb-2">IV.- Propiedad intelectual e industrial</h4>
              <p>
                El usuario reconoce que no le corresponden los derechos de
                propiedad intelectual e industrial sobre los gráficos, textos,
                planos, botones y, con carácter general, toda la información
                contenida en las páginas o sitios web a los que acceda y que la
                reproducción, carga, presentación, ejecución, transmisión,
                almacenamiento, traducción, adaptación, arreglo o distribución,
                ya sea total, ya sea parcial, realizados sin el consentimiento y
                autorización expresa de AXA constituye una infracción de los
                derechos de propiedad intelectual e industrial.
              </p>
              <p>
                AXA no concede ninguna licencia o autorización de uso de ninguna
                clase sobre sus derechos de propiedad industrial e intelectual o
                sobre cualquier otra propiedad o derecho relacionado con la
                página web, los Servicios o los Contenidos.
              </p>

              <h4 className="mb-2">
                V.- Responsabilidad por daños y perjuicios
              </h4>
              <p>
                El usuario responderá por los daños y perjuicios que pudiera
                ocasionar a AXA por el incumplimiento de las instrucciones y
                Condiciones Generales de uso del servicio cuando hubiere mediado
                dolo, culpa o negligencia.
              </p>

              <h4 className="mb-2">
                VI.- Calidad del servicio y medidas de seguridad
              </h4>
              <p>
                AXA ha adoptado los niveles de seguridad y medios técnicos a su
                alcance para garantizar la confidencialidad de la información y
                los datos personales facilitados en el acceso a esta web. No
                obstante lo anterior, el usuario debe ser consciente de que las
                medidas de seguridad en Internet no son inexpugnables. El acceso
                a esta página no implica, por parte de AXA, el control de virus
                o cualquier otro elemento informático dañino.
              </p>
              <p>
                Corresponde, en todo caso, al usuario la obligación de disponer
                de herramientas adecuadas para la detección y, en su caso,
                supresión de tales elementos.
              </p>

              <h4 className="mb-2">
                VII.- Responsabilidad por los enlaces incluidos en la red
              </h4>
              <p>
                Los hipervínculos (o links) a sitios del Grupo AXA y a terceras
                partes dependen de cada sitio enlazado y los contenidos de
                dichas páginas son responsabilidad de la entidad titular de
                éstas.
              </p>
              <p>
                AXA no será responsable de la información que dirija al cliente
                de sus servicios a través de los enlaces o links de terceros que
                pudieran existir, siempre que no tenga conocimiento efectivo de
                que la actividad o la información a la que remiten o recomiendan
                dichos enlaces o links es ilícita o de que lesiona bienes o
                derechos de un tercero susceptibles de indemnización, o si lo
                tiene, actúe con diligencia para suprimir o inutilizar el enlace
                correspondiente.
              </p>
              <p>
                Aunque AXA no es responsable del estado de actualización de los
                contenidos de terceros enlazados desde su web, sí se compromete
                a que los mencionados enlaces estén operativos y funcionen
                correctamente.
              </p>

              <h4 className="mb-2">VIII.- Denegación del acceso</h4>
              <p>
                AXA se reserva la facultad de denegar o retirar el acceso a la
                página web en cualquier momento a aquellos usuarios que
                incumplan con las Condiciones Generales de uso del servicio o
                las que, en su caso, resultaren de aplicación, así como a
                aquellos que realicen un uso inadecuado del servicio.
              </p>

              <h4 className="mb-2">IX.- Uso de los contenidos</h4>
              <p>
                La información facilitada a través de esta página es de carácter
                orientativo.
              </p>
              <p>
                El usuario se obliga a usar los Contenidos de buena fe, de forma
                diligente, correcta y lícita y, en particular, se compromete a
                abstenerse de:
              </p>
              <ol type="a" className="list mb-4">
                <li>
                  utilizar los Contenidos de forma, con fines o efectos
                  contrarios a la ley, a la moral y a las buenas costumbres
                  generalmente aceptadas, en especial las normas de
                  comportamiento en Internet, o al orden público;
                </li>
                <li>
                  reproducir o copiar, distribuir, permitir el acceso del
                  público a través de cualquier modalidad de comunicación
                  pública, transformar o modificar los Contenidos, a menos que
                  se cuente con la autorización del titular de los
                  correspondientes derechos o ello resulte legalmente permitido;
                </li>
                <li>
                  suprimir, eludir o manipular el &quot;copyright&quot; y demás
                  datos identificativos de los derechos de AXA o de sus
                  titulares incorporados a los Contenidos;
                </li>
                <li>
                  emplear los Contenidos y, en particular, la información de
                  cualquier clase obtenida a través de la web o de los Servicios
                  para remitir publicidad, comunicaciones con fines de venta
                  directa o con cualquier otra clase de finalidad comercial,
                  mensajes no solicitados dirigidos a una pluralidad de personas
                  con independencia de su finalidad, así como a comercializar o
                  divulgar de cualquier modo dicha información.
                </li>
              </ol>

              <h4 className="mb-2">
                X.- Exclusión de garantías y de responsabilidad
              </h4>
              <p>
                1.- Exclusión de garantías y de responsabilidad por el
                funcionamiento del Portal y de los Servicios.
              </p>
              <p>
                <strong>
                  Disponibilidad, continuidad, utilidad y falibilidad.
                </strong>
              </p>
              <p>
                AXA no garantiza la disponibilidad y continuidad del
                funcionamiento de la web o de los Servicios. Cuando ello sea
                razonablemente posible, AXA advertirá previamente de las
                interrupciones en el funcionamiento de la web y de los
                Servicios. AXA tampoco garantiza la utilidad ni de la web ni de
                los Servicios para la realización de ninguna actividad en
                particular, ni su infalibilidad y, en particular, aunque no de
                modo exclusivo, que los usuarios puedan efectivamente utilizar
                la web y los Servicios, acceder a las distintas páginas web o a
                aquellas desde las que se prestan los Servicios.
              </p>
              <p>
                AXA no se responsabiliza por los daños y perjuicios de toda
                naturaleza que puedan deberse a la falta de disponibilidad o de
                continuidad del funcionamiento de la web y de los servicios, y
                en particular, aunque no de modo exclusivo, a los fallos en el
                acceso a las distintas páginas web o a aquellas desde las que se
                prestan los servicios.
              </p>
              <p>
                <strong>
                  Privacidad y seguridad en la utilización de la web y de los
                  Servicios.
                </strong>
              </p>
              <p>
                AXA garantiza la privacidad y seguridad del sitio web y de los
                servicios que se ofrecen en el mismo, no obstante, AXA no es
                responsable de los daños que se puedan ocasionar a los usuarios
                si se produce un acceso por parte de terceros no autorizados y
                estos acceden a las condiciones, características y
                circunstancias del uso que los usuarios hacen de la web y de los
                Servicios.
              </p>
              <p>
                2.- Exclusión de garantías y de responsabilidad por los
                Contenidos. AXA no controla ni garantiza la ausencia de virus ni
                de otros elementos en los Contenidos que puedan producir
                alteraciones en su sistema informático (software y hardware) o
                en los documentos electrónicos, en la disponibilidad o
                continuidad de los ficheros almacenados en su sistema
                informático.
              </p>
              <p>
                AXA no se responsabiliza por los daños y perjuicios de toda
                naturaleza que puedan deberse a la presencia de virus o a la
                presencia de otros elementos en los contenidos que puedan
                producir alteraciones en el sistema informático, documentos
                electrónicos o ficheros de los usuarios.
              </p>
              <p>
                3.- Exclusión de garantías y de responsabilidad por los
                servicios y contenidos alojados fuera de la web. La web pone a
                disposición de los usuarios dispositivos técnicos de enlace
                (tales como, links, banners, botones), directorios y
                herramientas de búsqueda que permiten a los usuarios acceder a
                sitios web pertenecientes a y/o gestionados por terceros (en
                adelante, &quot;Sitios Enlazados&quot;). La instalación de estos
                enlaces, directorios y herramientas de búsqueda en la web tiene
                por único objeto facilitar a los usuarios la búsqueda y acceso a
                la información disponible en Internet.
              </p>
              <p>
                AXA no ofrece ni comercializa, por sí misma ni por medio de
                terceros, los productos y servicios disponibles en los Sitios
                Enlazados. El usuario, por tanto, debe extremar la prudencia en
                la valoración y utilización de los servicios, información,
                datos, archivos, productos y cualquier clase de material
                existente en los Sitios Enlazados.
              </p>
              <p>AXA no garantiza ni asume ningún tipo de responsabilidad por:</p>
              <ol type="a" className="list mb-4">
                <li>
                  los daños y perjuicios de toda clase que puedan deberse a
                  información, datos, archivos, productos y cualquier clase de
                  material existente en los sitios enlazados.
                </li>
                <li>
                  el funcionamiento, disponibilidad, accesibilidad o continuidad
                  de los sitios enlazados;
                </li>
                <li>
                  el mantenimiento de los servicios, contenidos, información,
                  datos, archivos, productos y cualquier clase de material
                  existente en los sitios enlazados;
                </li>
                <li>
                  la prestación o transmisión de los servicios, contenidos,
                  información, datos, archivos, productos y cualquier clase de
                  material existente en los sitios enlazados;
                </li>
                <li>
                  la calidad, licitud, fiabilidad y utilidad de los servicios,
                  contenidos.
                </li>
              </ol>

              <h4 className="mb-2">
                XI.- Duración de la prestación del servicio
              </h4>
              <p>
                La prestación del servicio tendrá, en principio, carácter
                indefinido. Cualquier modificación posterior del contenido de
                este Aviso Legal será publicada por este mismo medio. Los
                cambios que se hagan por cuestiones legales entrarán en vigor de
                forma inmediata.
              </p>

              <h4 className="mb-2">
                XII.- Ley aplicable y jurisdicción competente
              </h4>
              <p>
                Para cualquier controversia o cuestión que pudiera derivarse de
                la aplicación, ejecución e interpretación del presente Acuerdo,
                las partes aplicarán los principios de la buena fe y se regirán
                por la normativa española. En caso de resolución judicial de
                conflictos, será competente el Tribunal en el que tuviera el
                domicilio el usuario, siempre y cuando éste tuviera la
                consideración de consumidor y se encontrase en territorio
                español.
              </p>
              <p>
                En el caso de que el usuario no tuviera tal consideración,
                siendo por tanto profesional o empresario o en el supuesto de
                que, siendo consumidor, tuviera éste su domicilio fuera de
                España, se someterán, con renuncia expresa a cualquier otro
                fuero, a los Juzgados y Tribunales de Madrid Capital.
              </p>

              <p className="text-soft text-center mt-5">
                Fecha de Publicación: 2026
              </p>
            </div>
          </PreviewCard>
        </Block>

        {/* @ts-ignore */}
        <Block className="d-flex justify-content-center">
          <GoBackButton hideWhenNoHistory />
        </Block>
      </div>
    </Content>
  </Page>
);

export default Legal;
